import React from 'react';
import classNames from 'classnames';
import { GridContainer, GridItem } from '@entur/grid';
import { StatusBadge } from '@entur/layout';
import { Heading1, LeadParagraph } from '@entur/typography';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Breadcrumbs } from './Breadcrumbs';
import SEO from './Seo';

import './ArticleHeader.scss';

const ArticleHeader: React.FC<{
  title: string;
  excerpt: any;
  img?: any;
  children?: React.ReactNode;
  titleIcon?: React.ReactNode;
  imageSrc?: string; //Url for SEO
  gatsbyImageData?: any; // Gatsby Image Data for optimized images
  useVideo?: string;
  videoPoster?: string;
  showTitles?: boolean;
  className?: string;
  alt?: string;
  isBeta?: boolean;
  hideMediaOnMobile?: boolean;
}> = ({
  title,
  excerpt,
  img,
  children,
  imageSrc,
  gatsbyImageData,
  alt,
  useVideo,
  videoPoster,
  showTitles = true,
  className,
  titleIcon,
  isBeta,
  hideMediaOnMobile = false,
}) => {
  const image = gatsbyImageData ? getImage(gatsbyImageData) : null;

  return (
    <>
      <SEO title={title} description={excerpt} image={imageSrc} />
      <div className={classNames('omtur-article-header', className)}>
        <div className="omtur-article-header__breadcrumbs">
          <Breadcrumbs />
        </div>
        {showTitles && (
          <GridContainer className="omtur-article-header__content">
            <GridItem small={12} medium={6}>
              <Heading1>
                {isBeta && <StatusBadge variant="success">Beta</StatusBadge>}
                {titleIcon}
                {title}
              </Heading1>
              <LeadParagraph style={{ marginTop: '0' }}>
                {excerpt}
              </LeadParagraph>
            </GridItem>

            <GridItem
              className={classNames('omtur-article-header__content__media', {
                'omtur-article-header__content__media--hide-on-mobile':
                  hideMediaOnMobile,
              })}
              small={12}
              medium={6}
            >
              {image && !useVideo && (
                <GatsbyImage
                  className="omtur-article-header__content__media--image"
                  image={image}
                  alt={alt ?? ''}
                  style={{ maxHeight: '20rem', maxWidth: '100%' }}
                />
              )}
              {imageSrc && !image && !useVideo && (
                <img
                  className="omtur-article-header__content__media--image"
                  src={imageSrc}
                  alt={alt ?? ''}
                />
              )}
              {useVideo && (
                <div style={{ height: '47rem', width: '100%' }}>
                  <video
                    controls
                    controlsList="nodownload"
                    style={{ width: '100%', height: '47rem' }}
                    poster={videoPoster}
                  >
                    <source src={useVideo} type="video/mp4" />
                  </video>
                </div>
              )}
              {children && !useVideo && children}
            </GridItem>
          </GridContainer>
        )}
      </div>
    </>
  );
};

export default ArticleHeader;
